import { render, staticRenderFns } from "./DownLogs.vue?vue&type=template&id=e2069a06&scoped=true&"
import script from "./DownLogs.vue?vue&type=script&lang=js&"
export * from "./DownLogs.vue?vue&type=script&lang=js&"
import style0 from "./DownLogs.vue?vue&type=style&index=0&id=e2069a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2069a06",
  null
  
)

export default component.exports